export default __webpack_public_path__ + "static/xy-histogram-with-mean-aggregation-a152774213e3ed338335750ffc396a71.png";